// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/sponsorship/sponsorship.proto (package dymensionxyz.dymension.sponsorship, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * Params is a module parameters.
 *
 * @generated from message dymensionxyz.dymension.sponsorship.Params
 */
export class Params extends Message<Params> {
  /**
   * MinAllocationWeight is a minimum portion of the user's voting power that
   * one can allocate to a single gauge. The value is measured in percentages
   * and must fall between 1 and 100 * 10^18, inclusive. The base unit is 10^-18%,
   * so
   *  * 1 --> 10^-18%
   *  * 10^18 --> 1%
   *  * 100 * 10^18 --> 100%.
   *
   * Example! If this parameter is 20 * 10^18, which implies 20%, then the min
   * allocation is 20%, and consequently, one can vote on a max of 5 gauges:
   * 100 / 20 = 5.
   *
   * @generated from field: string min_allocation_weight = 1;
   */
  minAllocationWeight = "";

  /**
   * MinVotingPower is a minimum voting power a user must have in order to be
   * able to vote. Denominated in aDYM.
   *
   * @generated from field: string min_voting_power = 2;
   */
  minVotingPower = "";

  constructor(data?: PartialMessage<Params>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.sponsorship.Params";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "min_allocation_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "min_voting_power", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Params {
    return new Params().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Params {
    return new Params().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Params {
    return new Params().fromJsonString(jsonString, options);
  }

  static equals(a: Params | PlainMessage<Params> | undefined, b: Params | PlainMessage<Params> | undefined): boolean {
    return proto3.util.equals(Params, a, b);
  }
}

/**
 * Distribution holds the distribution plan among gauges. Distribution with the
 * Merge operation forms an Abelian group:
 * https://en.wikipedia.org/wiki/Abelian_group. Which helps to safely operate
 * with it. That is, Distribution:
 *   1. Is commutative:           a + b = b + a
 *   2. Is associative:           a + (b + c) = (a + b) + c
 *   3. Has the identity element: e + a = a + e = a
 *   4. Has inverse elements:     i + a = a + i = e
 * where
 * a, b, c, i, e : Distribution type,
 * + : Merge operation (Merge method)
 * i : inverse of a (Negate method),
 * e : identity element (zero, NewDistribution method).
 *
 * Example 1:
 *   a     : [100, 1] [50, 2] [0, 3] power 100
 *   b     : [160, 1] [40, 2] [5, 3] power 200
 *   a + b : [260, 1] [90, 2] [5, 3] power 300
 *
 * Example 2:
 *   a     : [100, 1] [50, 2] [0, 3] power 100
 *   b     : [160, 1]                power 200
 *   a + b : [260, 1] [50, 2] [0, 3] power 300
 *
 * Example 3:
 *   a     : [100, 1] [50, 2] [0, 3]          power 100
 *   b     :                         [160, 4] power 200
 *   a + b : [100, 1] [50, 2] [0, 3] [160, 4] power 300
 *
 * Example 4:
 *   a     : [210, 1] [180, 2] [210, 3] power 600
 *   -b    : [-40, 1] [-10, 2]          power -50
 *   a - b : [170, 1] [180, 2] [210, 3] power 550
 *
 * Example 5:
 *   a         : [210, 1] [180, 2] [210, 3] power 600
 *   e         :                            power 0
 *   a + e = a : [210, 1] [180, 2] [210, 3] power 600
 *
 * Example 6:
 *   a         : [ 210, 1] [ 180, 2] [ 210, 3] power  600
 *   i = -a    : [-210, 1] [-180, 2] [-210, 3] power -600
 *   a + i = e :                               power 0
 *
 * CONTRACT: Gauges are sorted by the gauge ID.
 * CONTRACT: Gauges hold gauges only with non-zero power.
 *
 * @generated from message dymensionxyz.dymension.sponsorship.Distribution
 */
export class Distribution extends Message<Distribution> {
  /**
   * VotingPower is the total voting power that the distribution holds.
   *
   * @generated from field: string voting_power = 1;
   */
  votingPower = "";

  /**
   * Gauges is a breakdown of the voting power for different gauges.
   *
   * @generated from field: repeated dymensionxyz.dymension.sponsorship.Gauge gauges = 2;
   */
  gauges: Gauge[] = [];

  constructor(data?: PartialMessage<Distribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.sponsorship.Distribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "voting_power", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gauges", kind: "message", T: Gauge, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Distribution {
    return new Distribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Distribution {
    return new Distribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Distribution {
    return new Distribution().fromJsonString(jsonString, options);
  }

  static equals(a: Distribution | PlainMessage<Distribution> | undefined, b: Distribution | PlainMessage<Distribution> | undefined): boolean {
    return proto3.util.equals(Distribution, a, b);
  }
}

/**
 * Gauge represents a single gauge with its absolute power.
 *
 * @generated from message dymensionxyz.dymension.sponsorship.Gauge
 */
export class Gauge extends Message<Gauge> {
  /**
   * GaugeID is the ID of the gauge.
   *
   * @generated from field: uint64 gauge_id = 1;
   */
  gaugeId = protoInt64.zero;

  /**
   * Power is a total voting power distributed to this gauge.
   *
   * @generated from field: string power = 2;
   */
  power = "";

  constructor(data?: PartialMessage<Gauge>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.sponsorship.Gauge";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gauge_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "power", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Gauge {
    return new Gauge().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Gauge {
    return new Gauge().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Gauge {
    return new Gauge().fromJsonString(jsonString, options);
  }

  static equals(a: Gauge | PlainMessage<Gauge> | undefined, b: Gauge | PlainMessage<Gauge> | undefined): boolean {
    return proto3.util.equals(Gauge, a, b);
  }
}

/**
 * Vote represents the user's vote.
 *
 * @generated from message dymensionxyz.dymension.sponsorship.Vote
 */
export class Vote extends Message<Vote> {
  /**
   * Voting power is a total voting power of the vote.
   *
   * @generated from field: string voting_power = 1;
   */
  votingPower = "";

  /**
   * Weights is a breakdown of the vote for different gauges.
   *
   * @generated from field: repeated dymensionxyz.dymension.sponsorship.GaugeWeight weights = 2;
   */
  weights: GaugeWeight[] = [];

  constructor(data?: PartialMessage<Vote>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.sponsorship.Vote";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "voting_power", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weights", kind: "message", T: GaugeWeight, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Vote {
    return new Vote().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Vote {
    return new Vote().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Vote {
    return new Vote().fromJsonString(jsonString, options);
  }

  static equals(a: Vote | PlainMessage<Vote> | undefined, b: Vote | PlainMessage<Vote> | undefined): boolean {
    return proto3.util.equals(Vote, a, b);
  }
}

/**
 * GaugeWeight is a weight distributed to the specified gauge.
 *
 * @generated from message dymensionxyz.dymension.sponsorship.GaugeWeight
 */
export class GaugeWeight extends Message<GaugeWeight> {
  /**
   * GaugeID is the ID of the gauge.
   *
   * @generated from field: uint64 gauge_id = 1;
   */
  gaugeId = protoInt64.zero;

  /**
   * Weight is a portion of the voting power that is allocated for the given gauge.
   * The value is measured in percentages and must fall between 1 and 100 * 10^18,
   * inclusive. The base unit is 10^-18%, so 
   * 	* 1 --> 10^-18%
   * 	* 10^18 --> 1%
   * 	* 100 * 10^18 --> 100%.
   *
   * @generated from field: string weight = 2;
   */
  weight = "";

  constructor(data?: PartialMessage<GaugeWeight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.sponsorship.GaugeWeight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gauge_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GaugeWeight {
    return new GaugeWeight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GaugeWeight {
    return new GaugeWeight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GaugeWeight {
    return new GaugeWeight().fromJsonString(jsonString, options);
  }

  static equals(a: GaugeWeight | PlainMessage<GaugeWeight> | undefined, b: GaugeWeight | PlainMessage<GaugeWeight> | undefined): boolean {
    return proto3.util.equals(GaugeWeight, a, b);
  }
}

